import { useEffect, useState } from "react";
import { Link } from "react-router-dom";

import apiCall from "../../helpers/apifactory";

const Rates = ({
  weight,
  origin,
  dstn,
  intl,
  zipcode,
  originLabel,
  dstnLabel,
}) => {
  const [rateteriff, setRateteriff] = useState();
  const [transits, setTransits] = useState();

  const getFare = () => {
    const isInternational = intl === "1";
    const body = {
      origincode: origin,
      destinationcode: dstn,
      weight: weight,
      ...(isInternational && { zipcode }),
    };
    const api = intl === "1" ? apiCall.getTarifInt : apiCall.getTarif;

    api
      .call(apiCall, body, {})
      .then((res) => {
        console.log("API Response:", res);
        let data = res?.data?.responseData?.data || [];
        data.sort((a, b) => b.totalamount - a.totalamount);
        setRateteriff(data);
      })
      .catch((error) => console.error("Something went wrong:", error));
  };

  useEffect(() => {
    if (!origin || !dstn || !weight) return;
    getFare();
  }, [origin, dstn, weight, intl, zipcode]);

  function toTitleCase(str) {
    return str.toLowerCase().replace(/\b\w/g, (char) => char.toUpperCase());
  }

  return (
    <div className="flex justify-center items-center my-6 sm:my-8 md:my-10 lg:my-4 px-4">
      <div className="w-full max-w-[57rem] flex flex-col justify-center rounded-md p-3 sm:p-4 md:px-6 md:py-2 shadow-my">
        <div className="flex flex-col sm:flex-row justify-between items-start sm:items-center gap-3 sm:gap-4 mb-2">
          <h1 className="text-xl sm:text-2xl md:text-3xl font-bold">Rates</h1>

          <Link
            to="/schedulePickUp"
            className="w-full sm:w-auto flex justify-center font-semibold items-center text-white bg-[#D40511] border border-[#F21E26] px-4 sm:px-6 rounded-md h-[2.5rem] sm:h-[2.8rem] text-xs sm:text-sm hover:bg-[#F21E26] hover:text-white transition-all duration-500"
          >
            Schedule A Pickup
          </Link>
        </div>

        {originLabel && dstnLabel && (
          <div className="mt-0 mb-0 text-center">
            <p className="text-base sm:text-lg md:text-xl font-semibold text-red-700 shadow-my py-2 px-4 rounded">
              {originLabel} <span className="mx-2">→</span> {dstnLabel}
            </p>
          </div>
        )}

        {/* Rates Table - Desktop View */}
        <div className="hidden md:block overflow-x-auto mt-2">
          <table className="w-full min-w-[600px]">
            <thead>
              <tr className="text-sm text-gray-800 bg-red-200 text-left">
                <th className="border p-2 sm:p-3">Service</th>
                <th className="border p-2 sm:p-3 text-center">
                  Service Charges
                </th>
                <th className="border p-2 sm:p-3 text-center">
                  Fuel Surcharges
                </th>
                <th className="border p-2 sm:p-3 text-center">GST Amount</th>
                <th className="border p-2 sm:p-3 text-center">Total Amount</th>
              </tr>
            </thead>
            <tbody>
              {rateteriff?.length > 0 &&
                rateteriff.map((r, index) => (
                  <tr
                    key={index}
                    className="text-sm text-gray-800 hover:bg-gray-50"
                  >
                    <td className="border p-2 sm:p-3">
                      {toTitleCase(r.title)}
                    </td>
                    <td className="border p-2 sm:p-3 text-right">
                      {Number(r.servicecharges).toLocaleString("en-US")}
                    </td>
                    <td className="border p-2 sm:p-3 text-right">
                      {Number(r.fuelcharges ?? r.fuelrate).toLocaleString(
                        "en-US"
                      )}
                    </td>
                    <td className="border p-2 sm:p-3 text-right">
                      {Number(r.gstrate).toLocaleString("en-US")}
                    </td>
                    <td className="border p-2 sm:p-3 text-right font-semibold">
                      {Number(r.totalamount).toLocaleString("en-US")}
                    </td>
                  </tr>
                ))}
            </tbody>
          </table>
        </div>

        {/* Rates Cards - Mobile/Tablet View */}
        <div className="md:hidden mt-5 space-y-4">
          {rateteriff?.length > 0 &&
            rateteriff.map((r, index) => (
              <div
                key={index}
                className="border border-gray-300 rounded-lg p-4 shadow-sm bg-white"
              >
                <div className="font-semibold text-base sm:text-lg text-gray-800 mb-3 pb-2 border-b border-gray-200">
                  {toTitleCase(r.title)}
                </div>
                <div className="space-y-2 text-sm">
                  <div className="flex justify-between items-center py-1">
                    <span className="text-gray-600">Service Charges:</span>
                    <span className="font-medium">
                      {Number(r.servicecharges).toLocaleString("en-US")}
                    </span>
                  </div>
                  <div className="flex justify-between items-center py-1">
                    <span className="text-gray-600">Fuel Surcharges:</span>
                    <span className="font-medium">
                      {Number(r.fuelcharges ?? r.fuelrate).toLocaleString(
                        "en-US"
                      )}
                    </span>
                  </div>
                  <div className="flex justify-between items-center py-1">
                    <span className="text-gray-600">GST Amount:</span>
                    <span className="font-medium">
                      {Number(r.gstrate).toLocaleString("en-US")}
                    </span>
                  </div>
                  <div className="flex justify-between items-center py-2 mt-2 pt-2 border-t border-gray-200">
                    <span className="text-gray-800 font-semibold">
                      Total Amount:
                    </span>
                    <span className="text-red-700 font-bold text-base">
                      {Number(r.totalamount).toLocaleString("en-US")}
                    </span>
                  </div>
                </div>
              </div>
            ))}
        </div>

        {/* Transit Section */}
        {transits && transits.length !== 0 && (
          <>
            <h1 className="text-xl sm:text-2xl md:text-3xl font-bold mt-6 sm:mt-8 mb-3 sm:mb-4">
              Transit
            </h1>

            {/* Transit Table - Desktop View */}
            <div className="hidden md:block overflow-x-auto mt-6">
              <table className="w-full min-w-[600px]">
                <thead>
                  <tr className="text-left text-sm text-gray-800 bg-gray-100">
                    <th className="border p-2 sm:p-3">Service</th>
                    <th className="border p-2 sm:p-3">Transit Days</th>
                    <th className="border p-2 sm:p-3">Pickup Date</th>
                    <th className="border p-2 sm:p-3">Pickup Time</th>
                    <th className="border p-2 sm:p-3">Arrival Date</th>
                    <th className="border p-2 sm:p-3">Arrival Time</th>
                  </tr>
                </thead>
                <tbody>
                  {transits.map((t) => (
                    <tr
                      className="text-sm text-gray-800 hover:bg-gray-50"
                      key={t.serviceCode}
                    >
                      <td className="border p-2 sm:p-3">{t.title}</td>
                      <td className="border p-2 sm:p-3">{t.transitDays}</td>
                      <td className="border p-2 sm:p-3">{t.originDeparture}</td>
                      <td className="border p-2 sm:p-3">{t.deliveryDate}</td>
                      <td className="border p-2 sm:p-3">{t.deliveryTime}</td>
                      <td className="border p-2 sm:p-3">
                        {t.deliveryTimeFrame}
                      </td>
                    </tr>
                  ))}
                </tbody>
              </table>
            </div>

            {/* Transit Cards - Mobile/Tablet View */}
            <div className="md:hidden mt-6 space-y-4">
              {transits.map((t) => (
                <div
                  key={t.serviceCode}
                  className="border border-gray-300 rounded-lg p-4 shadow-sm bg-white"
                >
                  <div className="font-semibold text-base sm:text-lg text-gray-800 mb-3 pb-2 border-b border-gray-200">
                    {t.title}
                  </div>
                  <div className="space-y-2 text-sm">
                    <div className="flex justify-between items-center py-1">
                      <span className="text-gray-600">Transit Days:</span>
                      <span className="font-medium">{t.transitDays}</span>
                    </div>
                    <div className="flex justify-between items-center py-1">
                      <span className="text-gray-600">Pickup Date:</span>
                      <span className="font-medium">{t.originDeparture}</span>
                    </div>
                    <div className="flex justify-between items-center py-1">
                      <span className="text-gray-600">Arrival Date:</span>
                      <span className="font-medium">{t.deliveryDate}</span>
                    </div>
                    <div className="flex justify-between items-center py-1">
                      <span className="text-gray-600">Arrival Time:</span>
                      <span className="font-medium">{t.deliveryTime}</span>
                    </div>
                    <div className="flex justify-between items-center py-1">
                      <span className="text-gray-600">Time Frame:</span>
                      <span className="font-medium">{t.deliveryTimeFrame}</span>
                    </div>
                  </div>
                </div>
              ))}
            </div>
          </>
        )}
      </div>
    </div>
  );
};

export default Rates;
